import { convertCharacters } from './convertCharacters';

const NOT_FOUND = -1;

function filterByText(
  item: any,
  fields: string[],
  searchText: string,
): boolean {
  const searchTextLower = new String(searchText).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return fields.some((field) => {
    const fieldValueLower = new String(item[field]).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return fieldValueLower.indexOf(searchTextLower) !== NOT_FOUND;
  });
}

export { filterByText };
